import React from 'react';
import {
  Image,
  ImageStyle,
  StyleProp,
  StyleSheet,
  TextStyle,
  ViewStyle,
} from 'react-native';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Text from '@/components/basic/text';
import {downIcon} from '@/common-pages/rebate/rebate.variables';

interface ShowMoreButtonProps {
  label: string;
  onPress: () => void;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  iconStyle?: StyleProp<ImageStyle>;
}

const ShowMoreButton = ({
  label,
  onPress,
  style,
  textStyle,
  iconStyle,
}: ShowMoreButtonProps) => {
  return (
    <NativeTouchableOpacity onPress={onPress} style={[styles.button, style]}>
      <Text style={[styles.text, textStyle]}>{label}</Text>
      <Image source={downIcon} style={[styles.icon, iconStyle]} />
    </NativeTouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: '100%',
    height: 40,
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    paddingHorizontal: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  text: {
    fontSize: 12,
    color: '#5C6575',
    textTransform: 'uppercase',
    letterSpacing: -0.3,
    fontWeight: '700',
  },
  icon: {
    width: 10,
    height: 11,
    marginLeft: 10,
    tintColor: '#9FA5AC',
  },
});

export default ShowMoreButton;
